import { NgModule } from '@angular/core';

import { PagamentoRestoRoutingModule } from './pagamento-resto-routing.module';
import { PagamentoRestoListComponent } from './pagamento-resto-list/pagamento-resto-list.component';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { IMaskModule } from 'angular-imask';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PagamentoRestoFormComponent } from './pagamento-resto-form/pagamento-resto-form.component';
import { SharedModule } from 'eddydata-lib';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PagamentoRestoRptComponent } from './pagamento-resto-rpt/pagamento-resto-rpt.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { InplaceModule } from 'primeng/inplace';
import { PagamentoComumModule } from '../pagamento-comum/pagamento-comum.module';
import { PagamentoRestoReinfComponent } from './pagamento-reinf-dlg/pagamento-resto-reinf.component';
import { InputMaskModule } from 'primeng/inputmask';
import { EmpenhoModule } from '../../empenho/empenho.module';
import { PagamentoAnulacaoComponent } from '../pagamento-anulacao/pagamento-anulacao.component';

@NgModule({
  declarations: [
    PagamentoRestoListComponent,
    PagamentoRestoFormComponent,
    PagamentoRestoRptComponent,
    PagamentoAnulacaoComponent,
    PagamentoRestoReinfComponent
  ],
  imports: [
    SharedModule,
    FormsModule,
    PagamentoRestoRoutingModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    IMaskModule,
    ToastModule,
    RadioButtonModule,
    ConfirmDialogModule,
    FieldsetModule,
    InplaceModule,
    PagamentoComumModule,
    InputMaskModule,
    EmpenhoModule
  ],
  providers: [MessageService, ConfirmationService]
})
export class PagamentoRestoModule { }
